import { LOGIN_REGISTER, ROUTESNAVBAR } from '../app.routes.constants';


export enum MenuLabel {
	HOME = 'Home',
	COME_FUNZIONA = 'Come funziona',
	CHI_SIAMO = 'Chi siamo',
	PREZZI = 'Prezzi',
	PROVA_ORA = 'Prova Ora',
	ACCEDI = 'Accedi',
	AREA_RISERVATA = 'Area Riservata',
	ESCI = 'Esci'
  }

  export enum MenuDropdownLabel {
  CAMBIO_PASS = 'Cambio password',
  PACCHETTI = 'Pacchetti acquistati'
  }


export interface MenuItem {
	label: string;
	link?: string;
	isButton?: boolean;
	hiddenLogin?: boolean;
	isAuthenticated?: boolean;
	dropDown ?: boolean;
	disabled ?: boolean;
}

export interface MenuDropdown {
	label: string;
	link ?: string;
}

export const MENU_ITEMS: MenuItem[] = [
	{ label: MenuLabel.HOME, link: ROUTESNAVBAR.HOME, isButton: false, },
	{ label: MenuLabel.COME_FUNZIONA, link: ROUTESNAVBAR.HOW_IT_WORKS, isButton: false, },
	{ label: MenuLabel.CHI_SIAMO, link: ROUTESNAVBAR.ABOUT_US, isButton: false, },
	{ label: MenuLabel.PREZZI, link: ROUTESNAVBAR.PRICING, isButton: false, },
	{ label: MenuLabel.PROVA_ORA,link:'/prova-ora', isButton: true, hiddenLogin: true},
	{ label: MenuLabel.ACCEDI, isButton: true, hiddenLogin: false },
	{ label: MenuLabel.AREA_RISERVATA, isButton: true, hiddenLogin: true, dropDown: true },
	{ label: MenuLabel.ESCI, isButton: true, hiddenLogin: true},
];

export const MENU_DROPDOWN: MenuDropdown[] = [
	{ label: MenuDropdownLabel.CAMBIO_PASS,  link: LOGIN_REGISTER.LOGIN_REGISTER_CHANGE},
	{ label: MenuDropdownLabel.PACCHETTI, link: LOGIN_REGISTER.PACCHETTI_ACQUISITI }
]